import Marionette from "backbone.marionette";
import templates from "../../../utils/templates";

const DEFAULTS = {
  className: "form-group card",
  template: templates.find("chart_reviews", "chart_edit_meta_member"),
};

class Member extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { Member as default };
